import { Link } from "react-router-dom";
import { ThemeToggleButton } from "../components/common/common/ThemeToggleButton";
import { CaseKeepLogo } from "../components/common/CaseKeepLogo/CaseKeepLogo";

interface LandingPageLayoutProps {
  children: React.ReactNode;
}

export const LandingPageLayout: React.FC<LandingPageLayoutProps> = ({
  children,
}) => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-end">
              <CaseKeepLogo className="dark:fill-white h-6 w-auto mr-2" />
              <span className="text-gray-900 dark:text-white text-lg">
                Case<span className="font-bold">keep</span>{" "}
                <span className="hidden lg:inline">
                  is a dead simple way to collect and share files with your
                  clients.
                </span>
              </span>
            </Link>

            {/* Right side actions */}
            <div className="flex items-center gap-1 sm:gap-3">
              <Link
                to="/security"
                className="inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
              >
                Security
              </Link>
              <Link
                to="/login"
                className="inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-white hover:bg-brand-600 transition-colors border border-gray-300 dark:border-gray-600 rounded-lg"
              >
                Sign In
              </Link>
              <Link
                to="/signup"
                className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-brand-600 rounded-lg hover:bg-brand-700 transition-colors shadow-sm"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>{children}</main>

      {/* Floating theme toggle */}
      <div className="fixed bottom-6 right-6 z-50">
        <ThemeToggleButton />
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <span className="text-gray-900 dark:text-white">
                Casekeep is made with ♥ in Hood River, Oregon USA
              </span>
              <span className="text-gray-300 dark:text-gray-600">|</span>
              <Link
                to="/about"
                className="text-gray-600 dark:text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
              >
                About
              </Link>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              © {new Date().getFullYear()} Casekeep. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPageLayout;
